module.exports = __webpack_public_path__ + "static/media/citrinehero.febef229.jpg";